import Panel from '../../control-components/panel'

const Robots = (props) => (
  <div>
    <Panel title='Details'>
      <textarea
        className='form-control'
        onKeyUp={(e) => props.onChange(e.target.value.trim())}
        rows='16'
      >{ props.data }</textarea>
    </Panel>
  </div>
)

export default Robots
